<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-toolbar
                    id="supplemental-messages-toolbar"
                    flat
                >
                    <v-row>
                        <v-col
                            cols="6"
                        >
                            <v-toolbar-title>
                                Supplemental Message
                            </v-toolbar-title>
                        </v-col>
                        <v-col
                            cols="6"
                            class="text-right"
                        >
                            <v-btn
                                class="ma-1 action-btn text-subtitle-2"
                                depressed
                                color="primary"
                                to="/settings/supplemental-messages/add"
                            >
                                <v-icon
                                    left
                                    class="action-icon"
                                >
                                    mdi-plus
                                </v-icon>
                                Add Supplemental Message
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row
            class="mt-0"
            :no-gutters="this.$vuetify.breakpoint.xs"
        >
            <v-col>
                <v-data-table
                    id="supplemental-messages-table"
                    :headers="headers"
                    :items="companyEmailSupplemental"
                    class="elevation-1 mx-2"
                    fixed-header
                    item-key="rowid"
                    dense
                >
                    <template v-slot:[`item.email_format`]="{item}">
                        <code class="code_supplemental">
                            {{ item.types }}
                            <br>
                            Ticket Format: {{ item.email_format }}
                        </code>
                    </template>
                    <template v-slot:[`item.criteria`]="{item}">
                        <code class="code_supplemental">
                            {{ item.classes }}
                            <br>
                            <pre
                                class="code_supplemental"
                                v-text="item.filterText"
                            />
                            <pre
                                class="code_supplemental"
                                v-text="item.member_codes !== '' ? item.member_codes : 'Any Member'"
                            />
                            <pre
                                class="code_supplemental"
                                v-text="item.days"
                            />
                            <pre
                                class="code_supplemental"
                                v-text="item.times"
                            />
                        </code>
                    </template>
                    <template v-slot:[`item.edit`]="{item}">
                        <v-icon
                            class="cp"
                            @click="editRule(item)"
                        >
                            mdi-pencil
                        </v-icon>
                    </template>
                    <template v-slot:[`item.delete`]="{item}">
                        <v-icon
                            class="cp"
                            @click="openDeleteRuleDialog(item)"
                        >
                            mdi-delete
                        </v-icon>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-dialog
            v-model="deleteRuleDialog"
            hide-overlay
            width="500"
        >
            <v-card>
                <v-card-title class="text-h5 lighten-2">
                    <span>Delete</span>
                </v-card-title>
                <v-divider />
                <v-card-text
                    class="py-5"
                    style="font-size: 16px"
                >
                    Are you sure you want to delete "{{ deleteRuleItem.name }}" from the supplemental messages list?
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        outlined
                        light
                        @click="deleteRuleDialog=false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        style="text-transform: none !important"
                        depressed
                        color="primary"
                        @click="deleteRule"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
            <v-overlay :value="loading">
                <div
                    v-if="loading"
                    class="d-flex justify-center align-center w-100p"
                    style="height: 70vh;"
                >
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    />
                </div>
            </v-overlay>
        </v-dialog>
    </v-container>
</template>

<script>
import webtmsBackend from '@/services/webtmsBackend';
import { hasPermission } from '../../../utils/permissions';

export default {
    name: 'SupplementalMessagesList',
    data: () => ({        
        loading: false,
        deleteRuleDialog: false,
        deleteRuleItem: {},
        supplementalEmailSms: hasPermission('SUPPLEMENTAL_EMAIL--SMS')
    }),
    computed: {
        getCenters() {
            return this.$store.getters.centers;
        },
        companyEmailSupplemental() {
            let days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
            let classes = ['Normal Priority', 'Emergency', 'Damage', 'Short', 'Rush', 'Late', 'Cancel', 'Update', 'Ongoing', 'Meet', 'Design', 'Remark', '2nd Notice', 'Non-Compliant'];
            let companyEmailSupplementalList = [...this.$store.getters.companyEmailSupplemental];
            companyEmailSupplementalList = companyEmailSupplementalList.map(item => {
                if(item.send_days) {
                    let send_days = item.send_days.split('');
                    item.days = [];
                    let daysIndex = 0;
                    for(let day of send_days) {
                        if(day === '1') {
                            item.days.push(days[daysIndex]);
                        }
                        daysIndex++;
                    }
                    if(item.days.length === 7) {
                        item.days = 'Any Day';
                    } else {
                        item.days = item.days.join(', ');
                    }
                }

                if(item.send_times == '') {
                    item.times = 'Any Time';
                } else {
                    item.times = item.send_times;
                }

                if(item.message_type) {
                    let message_type = item.message_type.split('');
                    item.types = [];
                    for(let type of message_type) {
                        if(type === 'T') {
                            item.types.push('Tickets');
                        } else if(type === 'A') {
                            item.types.push('Audits');
                        } else if(type === 'M') {
                            item.types.push('Messages');
                        }
                    }
                    item.types = item.types.join(', ');
                }

                if(item.stype_filter) {
                    let stype_filter = item.stype_filter.split('');
                    stype_filter.splice(0, 2);
                    let classIndex = 0;
                    item.classes = [];
                    for(let classe of stype_filter) {
                        if(classe === '0') {
                            item.classes.push('No ' + classes[classIndex]);
                        } else if(classe === '1') {
                            item.classes.push(classes[classIndex]);
                        }
                        classIndex++;
                    }
                    if(item.classes.length) {
                        item.classes = item.classes.join(', ');
                    }
                }

                if(item.filter_ctrpritypcat) {
                    let filterText = '';
                    let filter_ctrpritypcat = item.filter_ctrpritypcat.split('|');
                    for(let rule of filter_ctrpritypcat) {
                        rule = rule.split(',');
                        let center = this.getCenters.find(item => item.center_id === Number(rule[0]));
                        filterText += center.center_tag + ' ';
                        if (rule[1] !== '*') { filterText += ' Pri: ' + rule[1]; }
                        if (rule[2] !== '*') { filterText += ' Typ: ' + rule[2]; }
                        if (rule[3] !== '*') { filterText += ' Cat: ' + rule[3]; }
                        filterText += '\n';
                    }
                    item.filterText = filterText;
                }

                return item;
            });
            return companyEmailSupplementalList;
        },
        headers() {
            let headers = [];
            headers.push({
                text: 'Name',
                align: 'left',
                sortable: false,
                value: 'name',
            });
            headers.push({
                text: 'E-Mail',
                align: 'left',
                sortable: false,
                value: 'email',
            });
            if(this.supplementalEmailSms) {
                headers.push({
                    text: 'SMS',
                    align: 'left',
                    sortable: false,
                    value: 'sms_cell_number',
                });
            }
            headers.push({
                text: 'Types',
                align: 'left',
                sortable: false,
                value: 'email_format',
            });
            headers.push({
                text: 'Criteria',
                align: 'left',
                sortable: false,
                value: 'criteria',
                width: '300px',
            });
            headers.push({
                text: 'Edit',
                align: 'center',
                value: 'edit',
                sortable: false,
            });
            headers.push({
                text: 'Delete',
                align: 'center',
                value: 'delete',
                sortable: false,
            });
            return headers;
        }
    },
    methods: {
        editRule(rule) {
            this.$store.commit('SET_SELECTED_EMAIL_SUPPLEMENTAL_RULE', rule);
            this.$router.push('/settings/supplemental-messages/edit');
        },
        openDeleteRuleDialog(rule) {
            this.deleteRuleDialog = true;
            this.deleteRuleItem  = rule;
        },
        async deleteRule() {
            this.loading = true;
            const response = await webtmsBackend.supplementalMessageRule({
                operation: 'delete',
                rowid: this.deleteRuleItem.rowid
            });
            if(response && response.result === 'OK') {
                await this.$store.dispatch('updateCompanyEmailSupplemental');
            }
            this.loading = false;
            this.deleteRuleDialog = false;
        }
    }
};

</script>

<style>
    #supplemental-messages-table .v-data-table-header tr th {
      background-color: var(--ll-surface-subtle);
    }
    code.code_supplemental {
        background-color: unset !important;
    }
</style>

